<template>
  <div class="flex flex-col items-center justify-center p-12 space-y-4">
    <div class="relative w-16 h-16">
      <div class="absolute inset-0 rounded-full border-4 border-slate-200"></div>
      <div class="absolute inset-0 rounded-full border-4 border-red-600 border-t-transparent animate-spin"></div>
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
      </div>
    </div>
    <div class="flex flex-col items-center">
      <span class="text-xs font-black uppercase tracking-[0.3em] text-slate-400 animate-pulse">Loading Equipment</span>
      <div class="flex gap-1 mt-2">
        <div class="w-1.5 h-1.5 bg-red-600/30 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div class="w-1.5 h-1.5 bg-red-600/30 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div class="w-1.5 h-1.5 bg-red-600/30 rounded-full animate-bounce"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
